import React, { Component } from "react";
//import ReactDOM from "react-dom";
//import classNames from "classnames";
import { Link } from "react-router-dom";
import { Card, CardHeader, Col } from "reactstrap";
import Swal from "sweetalert2";
import Image3DViewer from "./Image3DViewer";
//import { rgbToHex } from "@coreui/coreui/dist/js/coreui-utilities";
import Axios from "axios";

import Car from "../carbodyparts/car";
//import CarDentTable from "../carbodyparts/CarDentTable";
import { configuration } from "../appConfig";
import { connect } from "react-redux";
import CarSVG from "../carbodyparts/CarSvg";
import Button from "reactstrap/lib/Button";
import CarDentTable from "../carbodyparts/CarDentTable";
import CarDentTableSwiss from "../carbodyparts/CarDentTableSwiss";
import CarDentTableAut from "../carbodyparts/CarDentTableAut";
import CarSvgSwiss from "../carbodyparts/CarSvgSwiss";
import CarSvgROM from "../carbodyparts/CarSvgROM";
import CarSvgFrench from "../carbodyparts/CarSvgFrench";
import "./twodview.css";
import CarSvgAUT from "../carbodyparts/CarSvgAUT";
import CanadaCarSVG from "../carbodyparts/CanadaCarSVG";
import USCarSVG from "../carbodyparts/USCarSVG";
import USCarDentTable from "../carbodyparts/USCarDentTable";
import axios from "axios";
import { reportAuthorized } from "../redux/actions/reportAuthorized";
import { toggleDamageImages } from "../redux/actions/showReportDamageImage";
import DamageToggleButton from "./common/DamageToggleButton";
import DnsDamageCarSvg from "../carbodyparts/DnsDamageCarSvg";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class VehicleDentInfo extends Component {
  state = {
    words: {},
    lang: "En",
    selectedFile: "",
    order: {
      vinNumber: "",
      orderNumber: Math.round(Math.random() * 100000000),
      issuedOn: new Date(),
    },
    partDetails: null,
    twoDView: true,
    vinNumber: null,

    vinfolderList: [],
    showTwoDView: true,
    selectedPartInfo: [],
    scanresult: [],
    data: {},
    showReportDamageImages: true,
    showDamageImages: 0,
    isUnviversalScan : 0
  };
  componentDidMount() {
    const selectedFile = localStorage.getItem("selectedFile");
    this.getData();
    this.setState({ vinNumber: selectedFile });
    // this.getData(selectedFile);
    this.vinFolderList();
    this.getLang();
    this._getImages();
  }
  getFallBackDetails = async () => {
    const url =
      configuration.getFallbackDetails +
      `?partner_id=${localStorage.getItem("partnerId")}`;
    await axios
      .get(url)
      .then((response) => {
        if (response && response.data) {
          this.setState({
            showDamageImages: response.data.is_damage_image,
            isUnviversalScan : response.data.is_universal_scan
            // showReportDamageImages : response.data.is_default_damage_image == 1 ? true : false
          });
          if (
            this.state.showReportDamageImages === undefined ||
            this.state.showReportDamageImages === null
          ) {
            this.setState({
              showReportDamageImages:
                response.data.is_default_damage_image == 1 ? true : false,
            });
          }
          this.props.toggleDamageImages(this.state.showReportDamageImages);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  getData = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url = `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`;
    await axios
      .get(url)
      .then((response) => {
        if (response && response.data) {
          this.setState({ data: response.data });
          this.props.reportAuthorized({
            Authorized: response.data.Authorized,
            DATReportAuthorized: response.data.DATReportAuthorized,
            MiniReportAuthorized: response.data.MiniReportAuthorized,
            FullReportAuthorized: response.data.FullReportAuthorized,
            FullReportAuthorized2: response.data.FullReportAuthorized2,
            DetailedReportAuthorized: response.data.DetailedReportAuthorized,
            AmericanReportAuthorized: response.data.AmericanReportAuthorized,
          });
          this.setState(
            {
              showReportDamageImages:
                response.data &&
                response.data.DamageImageToggle &&
                response.data.DamageImageToggle,
            },
            () => {
              this.getFallBackDetails();
            }
          );
        } else this.setState({ data: {} });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  _getImages = async () => {
    const selectedFile = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    await Axios.get(
      configuration.getImages +
        "?vin=" +
        selectedFile +
        "&partnerId=" +
        partnerId
    )
      .then((res) => {})
      .catch((err) => {});
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    //alert(nextProps.lang+"123")
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  handleChange = (e) => {
    this.setState({
      customerInfo: {
        ...this.state.customerInfo,
        [e.target.name]: e.target.value,
      },
    });
  };
  customerInfo = async () => {
    //alert('No Partner Id selected! Please login.')

    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
          "?partnerId=" +
          partnerId +
          "&vin=" +
          vin
      );
      if (res.data.length) {
        this.setState({ customerInfo: res.data[0] });
      }
    } else {
      // this.props.history.push('/login');
      // alert('No Partner Id selected! Please login.')
    }
  };
  vinFolderList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    if (partnerId) {
      const response = await Axios.get(
        configuration.resultTxt +
          "?vin=" +
          selectedFile +
          "&partnerId=" +
          partnerId
      );
      if (response.data[0] && response.data[0].resultTXT) {
        this.setState({
          vinfolderList: response.data,
          scanresult: response.data[0].resultTXT,
        });
      } else {
        // alert('Data not available.')
      }

      //console.table(response.data);
    } else {
      this.props.history.push("/login");
    }
  };

  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };
  showDummyData = () => {
    //this.getData(this.state.selectedFile);
    this.customerInfo();
  };

  SizeDropdown = (size, index) => {
    const arr = [0, 10, 20, 30, 40, 50, 60, 70, 80];
    return (
      <select value={size} onChange={(e) => this.change(e.target.value, index)}>
        {arr.map((row, i) => (
          <option key={i}>{row}</option>
        ))}
      </select>
    );
  };
  change = (val, index) => {
    //
    const { scanresult } =
      this.state.vinfolderList.length && this.state.vinfolderList[0].resultTXT;

    scanresult[index].size = val;
    this.setState({ scanresult });
    const result = window.confirm("Are you sure want to change Size?");
    if (result) {
      const url = configuration.Update_ResultTxt;
      let payload = {
        scanresult: scanresult,
        partnerId: localStorage.getItem("partnerId"),
        vin: localStorage.getItem("selectedFile"),
      };
      Axios.post(url, payload).then((res) => {
        Toast.fire({
          type: "success",
          title: "Data saved successfully",
        });
      });
    }
  };

  showData = (partName) => {
    // const obj = {
    //   vin: this.state.vinNumber,
    //   image: partName + "_1"
    // };
    //alert(partName);
    this.props.history.push("PartDetails/" + partName, { part: partName });

    // this.getPartDetailsService(obj);
    //if (!this.state.vinNumber) {
    //   Swal.fire('Oops...', "VIN NUMBER not selected ", 'error');
    //   return
    // }

    // this.setState({
    //   showTwoDView: false,
    //   partName: partName + "_1"

    // });
  };
  backtoDashboard = () => {
    this.props.history.push("/dashboard");
    sessionStorage.setItem("isScrolled", false);
  };
  handleToggleDamageImages = (e) => {
    const showReportDamageImages = e.target.checked;
    this.setState({
      showReportDamageImages,
    });
    this.props.toggleDamageImages(showReportDamageImages);
    this.updateToggleDamageImages(showReportDamageImages);
  };
  updateToggleDamageImages = async (showReportDamageImages) => {
    console.log(showReportDamageImages);
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url =
      configuration.PostEditorChanges +
      `?partnerId=${partnerId}&vin=${vin}&TabViewUpdated=${true}`;
    const payload = {
      ...this.state.data,
      DamageImageToggle: showReportDamageImages,
    };
    await axios
      .post(url, payload)
      .then((response) => {
        if (response && response.data && response.data.status == 200) {
          Toast.fire({
            type: "success",
            title: "Data saved successfully",
          });
          this.getData();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  render() {
    //const selectedFile = localStorage.getItem("selectedFile");

    const { orderNumber } = this.state.order;
    const client = localStorage.getItem("client");

    const scanResult =
      this.state.vinfolderList.length && this.state.vinfolderList[0];
    scanResult.resultTXT &&
      scanResult.resultTXT.scanresult &&
      scanResult.resultTXT.scanresult.filter((row) => {
        if (row.size) {
          let size = row.size - (row.size % 10);
          return (row.size = row.size % 10 >= 5 ? size + 10 : size);
        } else {
          return row;
        }
      });

    //const dentInfo = scanResult.resultTXT;

    return (
      <>
        <div className="animated fadeIn twod_view_main_wrapper">
          <Col xs="12" sm="12">
            <Card className="print_button_card mt-2">
              <CardHeader>
                <div className="container-fluid">
                  <div className="row align-items-center p-0">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12 mt-sm-10">
                      <div className="btn-position">
                        <Button
                          className="btn-danger mr-2"
                          onClick={() => this.backtoDashboard()}
                        >
                          {this.lang("Back")}
                        </Button>
                        {/* <strong>{this.lang("2D View")}</strong> */}
                        <small>
                          {" "}
                          {["SWISS", "US", "CANADA", "POLAND"].includes(
                            client
                          ) ? (
                            <span>{this.lang("DashboardVIN")} : </span>
                          ) : (
                            <span>{this.lang("VIN Number")} : </span>
                          )}
                          &nbsp; {localStorage.getItem("selectedFile")}{" "}
                        </small>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                      <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                        {this.state.showDamageImages == "1" ||
                        this.state.showDamageImages == 1 ? (
                          <div className="d-flex align-items-center">
                            <DamageToggleButton
                              lang={this.lang}
                              showReportDamageImages={
                                this.state.showReportDamageImages
                              }
                              handleToggleDamageImages={
                                this.handleToggleDamageImages
                              }
                            />
                          </div>
                        ) : (
                          ""
                        )}
                        {/* <small>   {["SWISS", "US", "CANADA"].includes(client) ? <span>{this.lang("DashboardVIN")} : </span> : 
                      <span>{this.lang("VIN Number")} : </span> }&nbsp; {localStorage.getItem("selectedFile")} </small> */}
                      </div>
                    </div>
                  </div>
                </div>
              </CardHeader>
            </Card>
            <Card className="m-0">
              {/* <CardHeader className="view_main_header_card">
                <div className="row align-items-center p-0">
                  <div className="col-lg-4=6 col-md-6 col-sm-12 mt-2 left_wrapper">
                      <Button className="btn-danger mr-2" onClick={()=>this.backtoDashboard()}>{this.lang("Back")}</Button>
                      <strong>{this.lang("2D View")}</strong>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-2 text-right">
                      <p> 
                      {this.lang("VIN Number")} : {localStorage.getItem("selectedFile")}
                  </p>
                  </div>
                </div>
              </CardHeader> */}
              <div className="row us_car_svg">
                <div className="col-lg-8 col-md-12 col-sm-12">
                  <div className="card">
                    <div className="card-body p-0">
                      {client === "ROM" ? (
                        <CarSvgROM
                          {...this.props}
                          is2Dview={true}
                          data={this.state.data}
                          showReportDamageImages={this.state.showReportDamageImages}
                        />
                      ) : client === "SWISS" || client === "POLAND" ? (
                        <CarSvgSwiss
                          {...this.props}
                          is2Dview={true}
                          data={this.state.data}
                          showReportDamageImages={this.state.showReportDamageImages}

                        />
                      ) : client == "FR" ? (
                        <CarSvgFrench
                          {...this.props}
                          is2Dview={true}
                          data={this.state.data}
                          showReportDamageImages={this.state.showReportDamageImages}

                        />
                      ) : client === "AUT" ? (
                        <CarSvgAUT
                          {...this.props}
                          is2Dview={true}
                          data={this.state.data}
                          showReportDamageImages={this.state.showReportDamageImages}

                        />
                      ) : client === "CANADA" ? (
                        <CanadaCarSVG
                          {...this.props}
                          is2Dview={true}
                          data={this.state.data}
                          showReportDamageImages={this.state.showReportDamageImages}

                        />
                      ) : client === "US" ? (
                        <USCarSVG
                          {...this.props}
                          is2Dview={true}
                          data={this.state.data}
                          showReportDamageImages={this.state.showReportDamageImages}

                        />
                      ) : (
                        this.state.isUnviversalScan == 1 ?
                        <DnsDamageCarSvg
                        {...this.props}
                        is2Dview={true}
                        data={this.state.data}
                        showReportDamageImages={this.state.showReportDamageImages}
                      /> :
                        <CarSVG
                          {...this.props}
                          is2Dview={true}
                          data={this.state.data}
                          showReportDamageImages={this.state.showReportDamageImages}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12 twod_table_view">
                  {["SWiSS", "POLAND"].includes(client) ? (
                    <CarDentTableSwiss data={this.state.data} />
                  ) : localStorage.getItem("client") == "AUT" ? (
                    <CarDentTableAut data={this.state.data} />
                  ) : ["US", "CANADA"].includes(client) ? (
                    <USCarDentTable data={this.state.data} />
                  ) : (
                    <CarDentTable data={this.state.data} />
                  )}
                </div>
              </div>
            </Card>
          </Col>
        </div>
      </>
    );
  }
}
const mapDispatchtoProps = (dispatch) => {
  return {
    reportAuthorized: (show) => dispatch(reportAuthorized(show)),
    toggleDamageImages: (show) => dispatch(toggleDamageImages(show)),
  };
};
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
    toggleReportDamageImage: props.toggleReportDamageImage,
  };
};
export default connect(mapStateToProps, mapDispatchtoProps)(VehicleDentInfo);
//export default Colors;
